// extracted by mini-css-extract-plugin
export var editButton = "_pt-0";